import * as THREE from 'three/webgpu';
import { isFeatureFace, isFeatureLine, isFeaturePoint } from '../../mesh/feature';
import { isDatumAxis } from '../../reference/DatumAxis';
import { isDatumPlaneObject } from '../../reference/DatumPlane';
import { isDatumPoint } from '../../reference/DatumPoint';
import type { MeasureEntityRef } from '../types/measure-types';

/**
 * 判断对象是否为测量点几何体（特征点或基准点）。
 *
 * @param object 场景对象。
 * @returns 是否为点几何体。
 */
export function isMeasurePointObject(
    object: THREE.Object3D | null | undefined,
): boolean {
    if (!object) {
        return false;
    }
    return isFeaturePoint(object) || isDatumPoint(object);
}

/**
 * 判断对象是否可作为测量拾取目标。
 *
 * @param object 场景对象。
 * @returns 是否可测量。
 */
export function isMeasurableObject(object: THREE.Object3D): boolean {
    return isFeatureFace(object)
        || isFeatureLine(object)
        || isFeaturePoint(object)
        || isDatumAxis(object)
        || isDatumPoint(object)
        || isDatumPlaneObject(object);
}

/**
 * 将射线命中解析为测量实体引用。
 *
 * @param pick 射线命中结果。
 * @returns 测量实体引用；不可测量时返回 null。
 */
export function resolveMeasureEntityRef(
    pick: THREE.Intersection<THREE.Object3D>,
): MeasureEntityRef | null {
    if (!isMeasurableObject(pick.object)) {
        return null;
    }

    return {
        objectId: pick.object.uuid,
        worldPickPoint: pick.point.clone(),
    };
}
